import { useSettings } from 'Settings'
import ValueTransform from 'ValueTransform'
import { v4 } from 'uuid'

import { TYPE } from 'configuration';

const edge_options = [
	{ value : 0, label : 'falling edge'},
	{ value : 1, label : 'rising edge'},
	{ value : 2, label : 'both edges'}
]

const f = (sup, sub) => {
	return `${sup}/${sub}`
}

const mppt_options = [
	{ value : 0, label : f(1,2)},
	{ value : 1, label : f(3, 5)},
	{ value : 2, label : f(2, 3)},
	{ value : 3, label : f(5, 7)},
	{ value : 4, label : f(3, 4)},
	{ value : 5, label : f(7, 9)},
	{ value : 6, label : f(4, 5)},
	{ value : 7, label : f(9, 11)},
	{ value : 8, label : f(5, 6)},
	{ value : 9, label : f(11, 13)},
	{ value : 10, label : f(6, 7)},
	{ value : 11, label : f(13, 15)},
	{ value : 12, label : f(7, 8)},
]

const row_content = {
	0 : {
		related : 'reg_t_hrv_period',
		value: 0,
		repr: (v, s) => {
			return `${2 ** v * 256} ms`
		}
	},
	1 : {
		related : 'reg_t_hrv_meas',
		value: 0,
		repr: (v, s) => {
			return `${2 ** v * 16} ms`
		}
	},
	2 : {
		related : 'reg_t_sts_period',
		value: 0,
		repr: (v, s) => {
			return `${2 ** v} ms`
		}
	},
	3 : {
		related : 'reg_t_lts_period',
		value: 0,
		repr: (v, s) => {
			return `${4 ** v} ms`
		}
	},
	4 : {
		related : 'reg_v_hrv_cfg',
		value: 0,
		repr: (v, s) => {
			const hps = s['harvester power supervisory']
			return `type: ${hps['harvesting element'].value}
	   v_hrv_min: ${hps['v_hrv_min'].value} V`
		}
	},
	5 : {
		related : 'reg_hrv_check_lvl',
		value: 0,
		repr: (v, s) => {
			const hps = s['harvester power supervisory']
			return `${hps['hrv_check_lvl'].value} μA`
		}
	},
	6 : {
		related : 'reg_lts_cfg',
		value: 0,
		repr: (v, s) => {
			return `battery protector: ${s['supervisory']['battery protector'].value}`
		}
	},
	7 : {
		related : 'reg_v_bat_max_hi',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_bat_max_hi'].value, acc).toString().substr(0, 5)} V`
		}
	},
	8 : {
		related : 'reg_v_bat_max_lo',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_bat_max_lo'].value, acc).toString().substr(0, 5)} V`
		}
	},
	9 : {
		related : 'reg_v_bat_min_hi_dis',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_bat_min_hi_dis'].value, acc).toString().substr(0, 5)} V`
		}
	},
	10 : {
		related : 'reg_v_bat_min_hi_con',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_bat_min_hi_con'].value, acc).toString().substr(0, 5)} V`
		}
	},
	11 : {
		related : 'reg_v_bat_min_lo',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_bat_min_lo'].value, acc).toString().substr(0, 5)} V`
		}
	},
	12 : {
		related : 'reg_v_apl_max_hi',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_apl_max_hi'].value, acc).toString().substr(0, 5)} V`
		}
	},
	13 : {
		related : 'reg_v_apl_max_lo',
		value: 0,
		repr: (v, s) => {
			const sl = s['supervisory level']
			const acc = sl['v_lvl_acc'].value
			return `${ValueTransform(sl['v_apl_max_lo'].value, acc).toString().substr(0, 5)} V`
		}
	},
	14 : {
		related : 'reg_ldo_cfg',
		value: 0,
		repr: (v, s) => {
			const ll = s['ldo levels']
			return `v_aux_ldo: ${ll['v_aux_ldo'].value} V
	   v_ulp_ldo: ${ll['v_ulp_ldo'].value} V`
		}
	},
	15 : {
		related : 'reg_pwr_cfg',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	16 : {
		related : 'reg_vaux_cfg',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	17 : {
		related : 'reg_vaux_gnd_cfg',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	18 : {
		related : 'reg_mppt_ratio',
		value: 0,
		repr: (v, s) => {
			return `${mppt_options[v].label}`
		}
	},
	19 : {
		related : 'reg_ext_cfg',
		value: 0,
		repr: (v, s) => {
			return `USB source: ${s['usb']['charging source'].value} V
	   Wake up on ${edge_options[s['wakeup']['edge'].value].label}`
		}
	},
	20 : {
		related : 'reg_t_sleep_vsup_lo',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	21 : {
		related : 'reg_t_sleep_vsup_mid',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	22 : {
		related : 'reg_t_sleep_vsup_hi',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	23 : {
		related : 'reg_t_hrv_low_cfg',
		value: 0,
		repr: (v, s) => {
			return `t_hrv_low_period: ${s['timing']['t_hrv_low_period'].value} ms
	   t_lts_hrv_low_period: ${s['timing']['t_lts_hrv_low_period'].value} ms`
		}
	},
	24 : {
		related : 'reg_spi_i2c_cfg',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
	25 : {
		related : 'reg_pwr_mgt',
		value: 0,
		repr: (v, s) => {
			return ``
		}
	},
}

const voltage_options = {
	"MAX" : [
		{ value : 1.32, label : 1.32 },
		{ value : 1.705, label : 1.705 },
		{ value : 1.815, label : 1.815 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.2, label : 2.2 },
		{ value : 2.42, label : 2.42 },
		{ value : 2.64, label : 2.64 },
		{ value : 2.86, label : 2.86 }
	],
	"TYP" : [
		{ value : 1.2, label: 1.2 },
		{ value : 1.55, label: 1.55 },
		{ value : 1.65, label: 1.65 },
		{ value : 1.8, label: 1.8 },
		{ value : 2, label: 2 },
		{ value : 2.2, label: 2.2 },
		{ value : 2.4, label: 2.4 },
		{ value : 2.6, label: 2.6 },
	],
	"MIN" : [
		{ value : 1.08, label : 1.08 },
		{ value : 1.395, label : 1.395 },
		{ value : 1.485, label : 1.485 },
		{ value : 1.62, label : 1.62 },
		{ value : 1.8, label : 1.8 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.16, label : 2.16 },
		{ value : 2.34, label : 2.34 }
	],
}

const ldoIndex = (value) => {
	let r = 0

	Object.entries(voltage_options).forEach(([,v]) => {
		const i = v.findIndex((val) => val.value === value)
		if (i !== -1) {
			r = i
		}
	})

	return r
}

const logn = (n, base) => {
	return Math.log(n) / Math.log(base)
}
const regValues = (settings, row_content) => {
	const { timing, supervisory, vsup, vaux, usb, wakeup } = settings
	const hps = settings['harvester power supervisory']
	const sl = settings['supervisory level']
	const ll = settings['ldo levels']
	const gnd = settings['vaux gnd']
	
	row_content[0].value = Math.log2(timing['t_hrv_period'].value / 256)
	row_content[1].value = Math.log2(timing['t_hrv_meas'].value / 16)
	row_content[2].value = Math.log2(timing['t_sts_period'].value)
	row_content[3].value = logn(timing['t_lts_period'].value, 4)

	row_content[4].value = hps['v_hrv_min'].value / 0.073 - 1

	if (hps['harvesting element'].value === 'teg') {
		row_content[4].value |= 0x40
	}

	row_content[5].value = hps['hrv_check_lvl'].value - 1
	row_content[6].value = (!supervisory['battery protector'].value) ? 1 : 0

	row_content[7].value = sl['v_bat_max_hi'].value
	row_content[8].value = sl['v_bat_max_lo'].value
	row_content[9].value = sl['v_bat_min_hi_dis'].value
	row_content[10].value = sl['v_bat_min_hi_con'].value
	row_content[11].value = sl['v_bat_min_lo'].value
	row_content[12].value = sl['v_apl_max_hi'].value
	row_content[13].value = sl['v_apl_max_lo'].value

	row_content[14].value = (vsup['behaviour when disabled'].value << 7) |
	                        (ldoIndex(ll['v_aux_ldo'].value) << 4)       |
	                        (vsup['force enable'].value << 3)            |
	                        (ldoIndex(ll['v_ulp_ldo'].value))

	row_content[15].value = (usb['always disable usb ldo'].value << 7)      |
	                        (gnd[2]['open in hrv_low mode'].value << 6)     |
	                        (gnd[1]['open in hrv_low mode'].value << 5)     |
	                        (gnd[0]['open in hrv_low mode'].value << 4)     |
	                        (vaux[2]['disable in hrv_low mode'].value << 3) |
	                        (vaux[1]['disable in hrv_low mode'].value << 2) |
	                        (vaux[0]['disable in hrv_low mode'].value << 1)

	row_content[16].value = (vaux[2]['constantly connect to'].value << 4) |
	                        (vaux[1]['constantly connect to'].value << 2) |
	                        (vaux[0]['constantly connect to'].value)

	row_content[17].value = (gnd[2]['connection'].value << 4) |
	                        (gnd[1]['connection'].value << 2) |
	                        (gnd[0]['connection'].value)

	row_content[18].value = hps['mppt ratio'].value

	row_content[19].value = (wakeup['sda'].value << 7)             |
	                        (wakeup['de-bouncer'].value << 6)      |
	                        ((wakeup['edge'].value + 1) << 4)      |
	                        (usb['force hrv_low hi-z'].value << 3) |
	                        (usb['force bat_low hi-z'].value << 2) |
	                        (usb['charging source'].value / 5)
	
	let ms = vsup['sleep'].value

	row_content[20].value = ms & 0x0000ff
	row_content[21].value = (ms & 0x00ff00) >> 8
	row_content[22].value = (ms & 0xff0000) >> 16

	row_content[23].value = (Math.log2(timing['t_hrv_low_period'].value / 256) << 4) |
	                        (logn(timing['t_lts_hrv_low_period'].value / 2, 4))

	row_content[24].value = (wakeup['3 wire interface'].value << 7) |
	                        (wakeup['i2c_address'].value)

	row_content[25].value = (gnd[2]['enable'].value << 6)  |
	                        (gnd[1]['enable'].value << 5)  |
	                        (gnd[0]['enable'].value << 4)  |
	                        (vaux[2]['enable'].value << 3) |
	                        (vaux[1]['enable'].value << 2) |
	                        (vaux[0]['enable'].value << 1) |
	                        (vsup['initial state'].value)
}

const ExportC = ({ className, onClick }) => {
	const [settings] = useSettings()
	const overwrite = settings['overwrite']
	regValues(settings, row_content)

	let values = ""

	Object.entries(row_content).forEach(([key, reg]) => {
		const repr = reg.repr(reg.value, settings)
		const value = overwrite[reg.related].value ? overwrite[reg.related].value : reg.value

		if (repr !== "") {
			values +=	`\t/* ${repr} */\n`
		}
		values += `	unsigned char ${reg.related} = 0x${value.toString(16)};\n\n`
	})

	values = values.substr(0, values.length - 1)

	const headerid = v4().toUpperCase().replace(/-/g, "")

	const dataStr = `#ifndef CONFIG_${headerid}_H
#define CONFIG_${headerid}_H

struct config {
${values}
};

#endif
`

	const dataUri = 'data:text/plain;charset=utf-8,' + encodeURIComponent(dataStr);

	const fileName = `config-${TYPE}.h`

	return (
		<a
			href={dataUri}
			download={fileName}
			className={className}
			onClick={onClick}
		>
			Export to C-Header
		</a>
	)
}

export default ExportC
export { row_content, regValues }
